import SoundManager from "../../../../../lib/html5-software-library/src/ranj/audio/SoundManager";
import Slice9Panel from "../../../../../lib/html5-software-library/src/ranj/components/scale9/Slice9Panel";
import RevisableLanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import LayoutManager from "../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import MediatorManager from "../../../core/application/MediatorManager";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import ClickEaterFactory from "../../../core/ui/ClickEaterFactory";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import MovieClipUtil from "../../util/MovieClipUtil";

export default class GameSavedNotificationOverlayScreenMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {ClickEaterFactory} clickEaterFactory 
     * @param {RevisableLanguagePack} languagePack 
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, languagePack) {
        super(target, dispatcher, layoutManager, clickEaterFactory);

        this._languagePack = languagePack;

        this._onboardingStepScreenMediator = null;
    }

    async initialize() {
        super.initialize();

        this._slicedPanel = new Slice9Panel(this._target.notificationPanel, MovieClipUtil.getFirstBitmapChild(this._target.notificationPanel), {
            mode: Slice9Panel.HORIZONTAL,
            pixelPerfect: true,
            overlap: false,
        });
        this._target.notificationPanel.textField.text = this._languagePack.getText(`saving.gameSavedNotice`);
        this._slicedPanel.update();

        await this._animateIn();
        this.closePopup(this._target);
    }

    async _animateIn() {
        this._target.notificationPanel.initialX = this._target.notificationPanel.x;
        this._target.notificationPanel.x = this._target.notificationPanel.initialX + 100;
        this._target.notificationPanel.alpha = 0;

        await createjs.Tween.get(this._target.notificationPanel)
            .to({ x: this._target.notificationPanel.initialX, alpha: 1, }, 650, createjs.Ease.backOut)
            .toPromise();

        await createjs.Tween.get(this._target.notificationPanel)
            .wait(3500)
            .to({ alpha: 0, }, 450, createjs.Ease.sineInOut)
            .toPromise();
    }
}